export const mCreativeAuditData = {
  top_creatives: [
    { title: "North Star Try-On Reel", format: "Video", platform: "IG Reels", age: "4d old", ctr: 6.8 },
    { title: "Power Running UGC", format: "UGC", platform: "TikTok", age: "7d old", ctr: 5.9 },
    { title: "Comfit Comfort-Tech Demo", format: "Video", platform: "YouTube", age: "12d old", ctr: 4.2 },
    { title: "Casual Lookbook Carousel", format: "Carousel", platform: "IG Feed", age: "9d old", ctr: 3.8 },
  ],
  fatigue_tracker: [
    { label: "Hero Banner — IG Feed", level: 85 },
    { label: "Product Grid — Facebook", level: 72 },
    { label: "Spring TVC Cut — YouTube", level: 60 },
    { label: "Comfort-Tech Static", level: 48 },
    { label: "Lookbook Shot — Pinterest", level: 35 },
  ],
  ai_recommendations: [
    { title: "Shift budget to short-form video", description: "Connect platforms to unlock this insight." },
    { title: "Refresh 4 fatigued creatives", description: "Connect platforms to unlock this insight." },
    { title: "Build native Reels & TikTok assets", description: "Connect platforms to unlock this insight." },
  ],
};
